import { BRIEFING_STATUS_LABELS, type BriefingStatus } from '@acasa/shared'

const TONES: Record<BriefingStatus, string> = {
  queued: 'border-line text-faint',
  // Not brand red: beside a failed (danger) chip the two would read as one.
  running: 'border-warning/40 bg-warning/10 text-ink',
  succeeded: 'border-done/40 bg-done/10 text-done',
  failed: 'border-danger/40 bg-danger/10 text-danger',
}

export function BriefingStatusChip({ status }: { status: BriefingStatus }) {
  return (
    <span className={`border px-1.5 py-0.5 text-[10px] whitespace-nowrap ${TONES[status]}`}>
      {BRIEFING_STATUS_LABELS[status]}
    </span>
  )
}
